export default __webpack_public_path__ + "static/media/avatar-loading-xxl.7ac79c6f.svg";